export function stringifyError(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === "string") return error;

    return JSON.stringify(error);
}
